import { useState, useMemo, useEffect, useRef } from 'react'
import { SelectMultiple as SelectMultipleTea, Bubble } from 'tea-component'

import SelectButton from '@/pages/dashboard/components/SelectButton'

import './index.scss'
import { Props, Options } from './types'

const SelectMultiple = (props: Props) => {
  const {
    value,
    defaultValue,
    options = [],
    label,
    isFirst,
    lastOneWarn = true,
    lastOneMessage = 'This option is the last one, after unchecking the competitor game will not have data.',
    onChange,
    ...othersProps
  } = props
  const defaultValueInner = options?.map(item => item.value) as string[]
  const nameMap = useMemo(() => {
    const map: any = {}
    options?.forEach(item => {
      if (!(item.text && item.value)) return
      map[item.text] = item
    })
    return map
  }, [options])
  const getNameValue = (value, options: Options = []) => {
    return options?.filter?.((item: any) => value.includes(item.value))?.map?.((item: any) => item.text) ?? []
  }

  const selectHistory = useRef([] as any)
  const [selectValue, setSelectValue] = useState(getNameValue(value ?? defaultValue ?? defaultValueInner, options))
  const [bubbleVisible, setBubbleVisible] = useState(false)
  const [dropdownVisible, setDropdownVisible] = useState(false)
  let valueList = options?.filter(item => selectValue?.includes(item.text))?.map(item => item.text)
  if (options?.length > 0 && options?.length === selectValue?.length || isFirst) {
    valueList = ['All']
  }

  const selectOptions = useMemo(() => {
    return options.map?.((item) => {
      return ({
        ...item,
        value: item.text ?? item.value,
        text: (
          <p className='select-multiple-item'>
            <img className='select-multiple-item-icon' src={item.icon} />
            <span className='select-multiple-item-text'>{item.text}</span>
          </p>
        ),
        tooltip: item.text
      })
    })
  }, [options])

  const handleChange = (nameValue) => {
    // 内部使用 nameValue 互相连接，外部使用真实的 value 传递
    const { value, sourceValue } = (() => {
      const value: string[] = []
      const sourceValue: any[] = []
      nameValue?.forEach(item => {
        value.push(nameMap?.[item]?.value)
        sourceValue.push(nameMap?.[item])
      })
      return {
        value,
        sourceValue
      }
    })()
    onChange?.(value)
    setSelectValue(nameValue)
  }

  const handleOpenChange = (visible) => {
    selectHistory.current = []
    setDropdownVisible(visible)
  }

  useEffect(() => {
    if (!value || !options) return
    setSelectValue(getNameValue(value, options))
  }, [JSON.stringify(value), JSON.stringify(options)])

  // 记录选择历史
  useEffect(() => {
    selectHistory.current = [
      ...selectHistory.current,
      selectValue
    ]
  }, [JSON.stringify(selectValue)])

  // 选择到最后一条时展示提示框，关闭弹窗重置显示逻辑
  useEffect(() => {
    setBubbleVisible(
      selectHistory?.current?.[selectHistory.current?.length - 2]?.length > 0 &&
      selectValue?.length === 1 && lastOneWarn &&
      dropdownVisible
    )
  }, [selectValue, lastOneWarn, dropdownVisible])

  return (
    <>
      <Bubble
        dark
        visible={bubbleVisible}
        content={lastOneMessage}
      >
        <SelectMultipleTea
          {...othersProps}
          appearance='button'
          boxClassName='select-multiple-container datalab-select-multiple'
          matchButtonWidth={true}
          staging={false}
          value={selectValue}
          defaultValue={selectValue}
          button={<SelectButton label={label} selectList={valueList as any} />}
          onChange={handleChange}
          options={selectOptions}
          allOption={{
            value: 'All',
            text: 'All'
          }}
          onOpenChange={handleOpenChange}
          searchable
        />
      </Bubble>
    </>
  )
}

export default SelectMultiple
